import { Link, Outlet, useLocation } from "react-router-dom";

const SettingsLayout = () => {
  const location = useLocation();

  return (
    <main className="min-h-screen bg-gray-100">
      <div className="container mx-auto px-6 py-8 bg-gray-100">
        <h1 className="text-3xl font-semibold mb-6">Settings</h1>

        <div className="flex flex-col md:flex-row gap-6">
          <aside className="w-full md:w-[180px]">
            <nav className="flex flex-wrap gap-4 text-sm text-muted-foreground md:flex-col">
              {/* <Link
                className={`${
                  location.pathname.includes("/account/general")
                    ? "font-semibold text-primary"
                    : "hover:text-primary"
                }`}
                to="general"
              >
                General
              </Link> */}
              <Link
                className={`${location.pathname.includes("/security") ? "font-semibold text-primary" : "hover:text-primary"}`}
                to="security"
              >
                Security
              </Link>
              {/* <Link
                className={`${location.pathname.includes("/billing") ? "font-semibold text-primary" : "hover:text-primary"}`}
                to="billing"
              >
                Plan & Billing
              </Link>
              <Link
                className={`${location.pathname.includes("/notifications") ? "font-semibold text-primary" : "hover:text-primary"}`}
                to="notifications"
              >
                Notifications
              </Link> */}
            </nav>
          </aside>

          <section className="flex-1">
            <Outlet />
          </section>
        </div>
      </div>
    </main>
  );
};

export default SettingsLayout;